export default __webpack_public_path__ + "static/media/O-008.0d692eb1.png";